import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import { Helmet } from 'react-helmet';
import * as QueryString from 'query-string';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import LoginForm from './LoginForm';
import loginBackground from '../../static/img/login_background2.jpg';
import sessionConstants from '../../constants/SessionConstants';
import warningIcon from '../../static/img/icons/login_icon_red.png';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 420,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  heading: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  main: {
    overflow: 'hidden',
    minHeight: '100vh',
    width: '100%',
    backgroundImage: `url(${loginBackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  smallMargin: {
    marginTop: theme.spacing(4),
  },
  largeMargin: {
    marginTop: theme.spacing(12),
  },
});

const reasonInfoPanelStyles = theme => ({
  paper: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  flexBox: {
    display: 'flex',
  },
  redirect: {
    fontSize: '12px',
    fontStyle: 'italic',
  },
  icon: {
    height: '32px',
    width: '32px',
  },
  padBottom: {
    paddingBottom: theme.spacing(1),
  },
});

let ReasonInfoPanel = (props) => {
  const { reason, classes } = props;

  let infoPanelText = {
    mainText: '',
    subText: '',
  };

  switch (reason) {
    case sessionConstants.SESSION_EXPIRED:
      infoPanelText.mainText = 'Please log in to access this page.';
      infoPanelText.subText = '';
      break;
    case sessionConstants.LOGIN_REQUIRED:
      infoPanelText.mainText = 'Please log in to access this page.';
      infoPanelText.subText = '';
      break;
    default:
  }

  return (
    <Paper className={classes.paper}>
      <img src={warningIcon} alt="error icon" className={classes.icon} />
      <Typography className={classes.padBottom}>{infoPanelText.mainText}</Typography>
      <Typography>{infoPanelText.subText}</Typography>
      <Typography className={classes.redirect}>You will be redirected after successful login.</Typography>
    </Paper>
  );
};

ReasonInfoPanel = withStyles(reasonInfoPanelStyles)(ReasonInfoPanel);

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to: '', // Location to route to after login, set from previous route query string param
      reason: '', // Reason for reroute after login
    };
  }

  componentDidMount() {
    const queryStringParam = QueryString.parse(this.props.location.search); // Accepts 'to' and 'reason' params
    const to = queryStringParam.to && decodeURIComponent(queryStringParam.to);
    const reason = queryStringParam.reason && decodeURIComponent(queryStringParam.reason);
    this.setState({ to, reason });
  }


  render() {
    const { classes } = this.props;
    const { to, reason } = this.state;
    return (
      <div className={classes.page}>

        <Helmet>
          <title>Login - NiaNow.com</title>
          <meta name="description" content="Login to your nianow.com account using your username or email and password. Access your account, class listings and membership. Dancing Through Life, Sacred Athlete, and Sacred Livelihood." />
          <meta name="keywaords" content="nia, login, account, homepage, membership" />
        </Helmet>

        <NavBar />
        <main className={classes.main}>
          <div className={classes.layout}>
            <div className={classes.appBarSpacer} />
            {/* <Typography color="textSecondary" variant="h4" className={classes.heading}>Login</Typography> */}
            {reason && <ReasonInfoPanel reason={reason} />}
            <div className={reason ? classes.smallMargin : classes.largeMargin}>
              <LoginForm to={to} />
            </div>
          </div>
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

ReasonInfoPanel.propTypes = {
  reason: PropTypes.string.isRequired,
  classes: PropTypes.object,
};

function mapStateToProps(state) {
  const { status, error } = state.loginReducer;
  return {
    status,
    error,
  };
}

export default withStyles(styles)(connect(mapStateToProps)(LoginPage));
